import React, { useEffect, useState } from "react";
import { useSupportAuth } from "../context/SupportAuthContext";

const formatLeft = (targetTime) => {
  const diffMs = Math.max(0, new Date(targetTime).getTime() - Date.now());
  const totalSec = Math.floor(diffMs / 1000);
  const min = String(Math.floor(totalSec / 60)).padStart(2, "0");
  const sec = String(totalSec % 60).padStart(2, "0");
  return { text: `${min}:${sec}`, expired: totalSec <= 0 };
};

const SessionTimer = () => {
  const { sessionEnd, logoutSupport } = useSupportAuth();
  const [, setTick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setTick((v) => v + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  // Recalculate every render so the timer stays accurate as time passes.
  const { text, expired } = formatLeft(
    sessionEnd || new Date(Date.now() + 20 * 60 * 1000).toISOString()
  );

  useEffect(() => {
    if (expired) {
      logoutSupport("Support session expired");
    }
  }, [expired, logoutSupport]);

  return (
    <div className="rounded-md border bg-white px-4 py-2 shadow-sm">
      <p className="text-xs text-gray-500">Session Time Remaining</p>
      <p className={`text-lg font-semibold ${expired ? "text-red-600" : "text-green-700"}`}>
        {text}
      </p>
    </div>
  );
};

export default SessionTimer;

